import { INDUSTRIES, CLIENTS } from "@/data/content";
import { Buildings } from "@phosphor-icons/react";

export const Industries = () => {
  const loop = [...INDUSTRIES, ...INDUSTRIES];
  return (
    <section id="industries" data-testid="industries-section" className="py-24 lg:py-32 bg-white border-t border-slate-200">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <span className="overline text-[#B91C1C]">Who we serve</span>
        <h2 className="mt-4 font-serif-display text-3xl lg:text-4xl font-bold tracking-tight text-slate-900 max-w-xl">
          Trusted across the lending ecosystem
        </h2>
      </div>

      <div className="mt-14 overflow-hidden border-y border-slate-200 py-8">
        <div className="marquee-track flex w-max gap-4 whitespace-nowrap">
          {loop.map((ind, i) => (
            <span key={i} className="font-serif-display text-2xl lg:text-3xl text-slate-300 px-6">
              {ind} <span className="text-[#B91C1C]">/</span>
            </span>
          ))}
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-6 lg:px-10 mt-20">
        <div className="flex items-center gap-3 mb-8">
          <Buildings weight="duotone" className="h-6 w-6 text-slate-900" />
          <span className="overline text-slate-500">Selected clients</span>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 border-t border-l border-slate-200">
          {CLIENTS.map((c) => (
            <div key={c.name} data-testid={`client-${c.name.replace(/\s+/g, "-").toLowerCase()}`}
              className="border-r border-b border-slate-200 p-8 flex flex-col justify-between min-h-[130px]">
              <p className="font-serif-display text-xl font-semibold text-slate-900">{c.name}</p>
              <span className={`mt-4 self-start text-xs font-medium px-2.5 py-1 ${c.status === "Active" ? "bg-slate-900 text-white" : "border border-slate-300 text-slate-500"}`}>
                {c.status}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
